export function hashCode(s) {
  var h = 0,
    l = s.length,
    i = 0;
  if (l > 0) while (i < l) h = ((h << 5) - h + s.charCodeAt(i++)) | 0;
  return h;
}

const MATERIAL_COLORS = [
  "#F56A00",
  "rgb(249, 166, 109)",
  "rgb(87, 190, 140)",
  "rgb(132, 122, 140)",
  "rgb(236, 94, 68)",
  "rgb(33, 33, 33)",
];

export function stringToColor(s, colors = null) {
  const code = hashCode(s);
  const _colorsArray = colors ? colors : MATERIAL_COLORS;
  const idx = code % _colorsArray.length;
  return _colorsArray[idx];
}

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
